module.exports = __webpack_public_path__ + "img/EuclidEnercity-Medium-WebS.d2ed4aae.svg";